"use client";
import React from "react";
import { Row, Col } from "@/utils/bootstrap";

const AssociatedProductsSkeleton: React.FC = () => {
  return (
    <div className="mt-4">
      {/* Title Skeleton */}
      <div style={{ marginBottom: 16 }}>
          <div style={{ width: 200, height: 24, marginBottom: 16 }} className="skeleton-rect rounded" />
      </div>

      <Row>
        {[1, 2, 3, 4].map((i) => (
          <Col key={i} xs={6} md={4} lg={3} className="mb-4">
            <div className="d-flex flex-column gap-2">
              <div style={{ width: "100%", paddingTop: "100%", position: 'relative' }} className="skeleton-rect rounded">
              </div>
              <div style={{ width: "80%", height: 16 }} className="skeleton-rect rounded" />
              <div style={{ width: "40%", height: 16 }} className="skeleton-rect rounded" />
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AssociatedProductsSkeleton;
